import React, { useState, useEffect } from "react";
import axios from "axios";
import { CSVLink } from "react-csv";
import { FileDown } from "lucide-react";

export default function Telephonique({ checked, fon }) {
    const headers = [
        { label: "ID", key: "id" },
        { label: "Nom", key: "nom" },
        { label: "Téléphone", key: "telephone" }
    ];

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [itemsPerPage] = useState(20);
    const [visiblePages, setVisiblePages] = useState([1, 2, 3, 4, 5]);

    useEffect(() => {
        fetchData();
    }, [currentPage]);

    const fetchData = async () => {
        try {
            const response = await axios.get('/cvs_pagination', {
                params: {
                    page: currentPage,
                    per_page: itemsPerPage
                }
            });

            setData(response.data.cvs || []); // Assure-toi que data est un tableau même si la réponse est vide
            setTotalPages(response.data.total_pages || 1); // Définit un totalPages par défaut de 1
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const updateVisiblePages = (page) => {
        let startPage, endPage;

        if (page <= 3) {
            startPage = 1;
            endPage = Math.min(5, totalPages);
        } else if (page + 2 >= totalPages) {
            startPage = Math.max(totalPages - 4, 1);
            endPage = totalPages;
        } else {
            startPage = page - 2;
            endPage = page + 2;
        }

        setVisiblePages(Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i));
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        updateVisiblePages(page);
    };

    return (
        <>
            <div className="d-flex">
                <div className="p-2">Tous les listes des numéros de téléphone</div>
                <div className="ml-auto p-2">
                    <CSVLink 
                        data={data.map(cv => ({
                            id: `${cv.id}`,
                            nom: `${cv.nomPrenom}`,
                            telephone: `${cv.telephone}`
                        }))}
                        headers={headers} 
                        className="btn btn-primary btn-sm"
                    >
                       <FileDown size={24} strokeWidth={1} /> Télécharger en format CSV
                    </CSVLink>
                </div>
            </div>
            <table className="table table-actions table-striped table-hover mb-0 dataTable no-footer" role="grid">
                <thead>
                    <tr>
                        <th scope="col">
                            <div className="form-check">
                                <input
                                    className=""
                                    type="checkbox"
                                    id="flexCheckDefault"
                                    onClick={() => fon()}
                                />
                            </div>
                        </th>
                        <th scope="col"><strong>ID</strong></th>
                        <th scope="col">Nom et prénom</th>
                        <th scope="col">Téléphone</th>
                        <th scope="col">Disponibilité</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map(cv => (
                        <tr key={cv.id}>
                            <th scope="row">
                                <div className="form-check">
                                    <input
                                        className=""
                                        type="checkbox"
                                        id="flexCheckDefault"
                                        checked={checked}
                                    />
                                </div>
                            </th>
                            <td><strong>0{cv.id}</strong></td>
                            <td>{cv.nomPrenom}</td>
                            <td>{cv.telephone}</td>
                            <td>
                                <h6>
                                    <span className="badge badge-pill badge-primary">
                                        {cv.disponibility}
                                    </span>
                                </h6>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <nav aria-label="Page navigation">
                <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage - 1)}
                        >
                            Précédent
                        </button>
                    </li>
                    {currentPage > 3 && (
                        <>
                            <li className="page-item">
                                <button
                                    className="page-link"
                                    onClick={() => handlePageChange(1)}
                                >
                                    1
                                </button>
                            </li>
                            {currentPage > 4 && <li className="page-item disabled"><span className="page-link">...</span></li>}
                        </>
                    )}
                    {visiblePages.map(number => (
                        <li
                            key={number}
                            className={`page-item ${number === currentPage ? 'active' : ''}`}
                            aria-current={number === currentPage ? 'page' : undefined}
                        >
                            <button
                                className="page-link"
                                onClick={() => handlePageChange(number)}
                            >
                                {number}
                            </button>
                        </li>
                    ))}
                    {currentPage < totalPages - 2 && (
                        <>
                            {currentPage < totalPages - 3 && <li className="page-item disabled"><span className="page-link">...</span></li>}
                            <li className="page-item">
                                <button
                                    className="page-link"
                                    onClick={() => handlePageChange(totalPages)}
                                >
                                    {totalPages}
                                </button>
                            </li>
                        </>
                    )}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage + 1)}
                        >
                            Suivant
                        </button>
                    </li>
                </ul>
            </nav>
        </>
    );
}
